import { render, staticRenderFns } from "./GameForm.vue?vue&type=template&id=4369da70&scoped=true"
import script from "./GameForm.vue?vue&type=script&lang=js"
export * from "./GameForm.vue?vue&type=script&lang=js"
import style0 from "./GameForm.vue?vue&type=style&index=0&id=4369da70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4369da70",
  null
  
)

export default component.exports